<template>
  <Navbar />
  <form @submit.prevent="handleSubmit">
    <h3>Log In</h3>
    <input type="email" placeholder="Email" v-model="email">
    <input type="password" placeholder="Password" v-model="password">
    <p>No account yet? <span @click="$router.push('/signup')">Signup</span> instead.</p>
    <div v-if="error" class="error">{{ error }}</div>
    <button v-if="!isPending">Log In</button>
    <button v-if="isPending">Loading</button>
  </form>
</template>

<script>
import { ref } from 'vue'
import Navbar from '../../components/Navbar'
import { useRouter } from 'vue-router'
import useLogin from '../../composables/useLogin'

export default {
  components: {
    Navbar
  },
  setup(){
    const email = ref('');
    const password = ref('');
    const router = useRouter();
    const { error, login, isPending } = useLogin();
    const handleSubmit = async () => {
      const res = await login(email.value, password.value);
      if(!error.value){
        router.push('/userArticle');
      }
    };
    return { email, password, handleSubmit, error, isPending }
  }
}
</script>

<style scoped>
form span {
  text-decoration: underline;
  font-weight: bold;
  cursor: pointer;
}
  
</style>